"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSmartCaptcha = void 0;
const react_1 = require("react");
const useSmartCaptchaLoader_1 = require("./useSmartCaptchaLoader");
function useSmartCaptcha(props, ref) {
    const { autoload } = props, params = __rest(props, ["autoload"]);
    const autoloadedRef = react_1.useRef(false);
    const smartCaptcha = useSmartCaptchaLoader_1.useSmartCaptchaLoader();
    const [widgetId, setWidgetId] = react_1.useState();
    const render = react_1.useCallback(() => {
        if (ref.current) {
            const widgetId = smartCaptcha === null || smartCaptcha === void 0 ? void 0 : smartCaptcha.render(ref.current, params);
            setWidgetId(widgetId);
        }
    }, [smartCaptcha, ref, params]);
    const getResponse = react_1.useCallback(() => {
        return smartCaptcha === null || smartCaptcha === void 0 ? void 0 : smartCaptcha.getResponse(widgetId);
    }, [smartCaptcha, widgetId]);
    const reset = react_1.useCallback(() => {
        smartCaptcha === null || smartCaptcha === void 0 ? void 0 : smartCaptcha.reset(widgetId);
    }, [smartCaptcha, widgetId]);
    const destroy = react_1.useCallback(() => {
        smartCaptcha === null || smartCaptcha === void 0 ? void 0 : smartCaptcha.destroy(widgetId);
        setWidgetId(undefined);
    }, [smartCaptcha, widgetId]);
    const execute = react_1.useCallback(() => {
        smartCaptcha === null || smartCaptcha === void 0 ? void 0 : smartCaptcha.execute(widgetId);
    }, [smartCaptcha, widgetId]);
    const subscribe = react_1.useCallback((event, callback) => {
        if (widgetId === undefined) {
            return;
        }
        return smartCaptcha === null || smartCaptcha === void 0 ? void 0 : smartCaptcha.subscribe(widgetId, event, callback);
    }, [smartCaptcha, widgetId]);
    react_1.useEffect(() => {
        if (autoload && !autoloadedRef.current && smartCaptcha) {
            render();
            autoloadedRef.current = true;
        }
    }, [smartCaptcha, render]);
    return {
        widgetId,
        render,
        getResponse,
        reset,
        destroy,
        execute,
        subscribe,
        smartCaptcha,
    };
}
exports.useSmartCaptcha = useSmartCaptcha;
